import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAsync, postAsync } from '../../../components/helper/axiosHelper';
import html2pdf from 'html2pdf.js';
import LoaderModal from '../../../components/common/LoaderModal';

const ViewCertificate = () => {
  const { giftLinkID } = useParams();
  const [userpdf, setUserpdf] = useState(null);
  const isMobile = () => window.innerWidth < 1023;
  const isDesktop = () => window.innerWidth >= 1024;
  const [currentDevice, setCurrentDevice] = useState(null); // Track the current device type

  const imagesArray = [
    { src: `${window.location.origin}/assets/images/certificates/عامGeneral.png` },
    { src: `${window.location.origin}/assets/images/certificates/الشفاءHealing.png` },
    { src: `${window.location.origin}/assets/images/certificates/العملGettingJob.png` },
    { src: `${window.location.origin}/assets/images/certificates/الوالدينParents.png` },
    { src: `${window.location.origin}/assets/images/certificates/مواليدBirths.png` },
    { src: `${window.location.origin}/assets/images/certificates/التخرجGraduation.png` },
    { src: `${window.location.origin}/assets/images/certificates/الزواجMarriage.png` },
    { src: `${window.location.origin}/assets/images/certificates/النجاحSuccess.png` },
    { src: `${window.location.origin}/assets/images/certificates/العيدEid.png` },
  ];

  useEffect(() => {
    localStorage.setItem('isHome', true);
    // generatePDF();
  }, []);

  useEffect(() => {
    checkDeviceType(); // Run on component mount

    // Set up an event listener for window resizing
    window.addEventListener('resize', checkDeviceType);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, [currentDevice, userpdf]);

  const checkDeviceType = () => {
    let newDevice = null;
    if (isMobile()) {
      newDevice = 'mobile';
    } else if (isDesktop()) {
      newDevice = 'desktop';
    }

    // Only call the API if the device type has changed
    if (newDevice && newDevice !== currentDevice) {
      setCurrentDevice(newDevice);
      if (newDevice === 'mobile') {
        generatePDFMob();
      } else if (newDevice === 'desktop') {
        generatePDFDesk();
      }
    }
  };
  // const generatePDF = async () => {
  //   await getAsync(`GiftService/BeneficiaryGiftService/${giftLinkID}`)
  //     .then((response) => {
  //       const result = response?.data[0];
  //       const htmlContent = `
  //         <div style="display: flex; justify-content: center; align-items: flex-start; overflow: hidden; width: 100%; height: auto;" id="pdf-content">
  //           <div style="position: relative; width: 100%; max-width: 450px;  height: auto;">
  //             <img
  //               style="width: 100%; height: 584px;"
  //               src="${imagesArray[result?.giftTypeID-1].src}"
  //               alt="Background"
  //             />
  //             <div style="text-align: right; position: absolute; top: calc(32% + 14px); right: calc(25% + 12px);">
  //               <div style="text-align: right; display: flex; flex-direction: column;">
  //                 <span style="font-size: 1rem; color: #ff8c00; font-weight: bold;">
  //                   ${result?.beneName || ''}
  //                 </span>
  //                 <p style="margin-top: 5rem;">${result?.projectName || ' '}</p>
  //                 <p style="font-size: 1.125rem; color: black; margin-top: 2rem;">
  //                   ${result?.senderName || ''}
  //                 </p>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       `;

  //       // Create a new element to render the HTML content for PDF
  //       const element = document.createElement('div');
  //       element.innerHTML = htmlContent;
  //       document.body.appendChild(element);

  //       // Measure the height of the content
  //       const contentHeight = element.offsetHeight;
  //       console.log("Calculated Content Height:", contentHeight); // Debugging log

  //       // Set a fixed maximum height for A4 size in pixels (for portrait orientation)
  //       const maxHeight = 1120; // A4 height in pixels approximately

  //       // Use html2pdf.js to generate PDF and save it to state
  //       html2pdf()
  //         .from(element)
  //         .set({
  //           margin: [0, 0, 0, 0], // No margins
  //           filename: 'generated.pdf',
  //           html2canvas: { scale: 2 }, // Optional for better quality
  //           jsPDF: {
  //             unit: 'px',
  //             format: [450, Math.min(contentHeight, maxHeight)], // Limit height to maxHeight
  //             orientation: 'portrait'
  //           }
  //         })
  //         .toPdf()
  //         .get('pdf')
  //         .then((pdf) => {
  //           const pdfBlob = pdf.output('blob');
  //           const pdfUrl = URL.createObjectURL(pdfBlob);

  //           // Save the Blob in the state
  //           setUserpdf(pdfUrl); // Save Blob URL for rendering

  //           // Clean up after generating the PDF
  //           document.body.removeChild(element);
  //         })
  //         .catch((error) => {
  //           console.error('Error generating PDF:', error);
  //         });
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching data:', error);
  //     });
  // };

  const generatePDFDesk = async () => {
    setUserpdf(null);

    // await response = getAsync(`GiftService/BeneficiaryGiftService/${giftLinkID}`)
    try {
      const response = await getAsync(`GiftService/BeneficiaryGiftService/${giftLinkID}`);
      const result = response?.data[0];
  
      // Dusra API call
      const getprojectName = await postAsync(`APIClient/ProjectListGUIDnoImage`, [
        {projectID:result?.projectID,projectTypeIdInt: result?.projectTypeIdInt},
      ]);
      const projectName = getprojectName?.data[0];
      const htmlContent = `
          <div style="display: flex; justify-content: center; align-items: flex-start; overflow: hidden; width: 100%; height: auto;" id="pdf-content">
            <div style="position: relative; width: 100%; max-width: 450px;  height: auto;">
              <img
                style="width: 100%; height: 584px;"
                src="${imagesArray[result?.giftTypeID - 1].src}"
                alt="Background"
              />
              <div style="text-align: right; position: absolute; top: calc(32% + 14px); right: calc(25% + 12px);">
                <div style="text-align: right; display: flex; flex-direction: column;">
                  <span style="font-size: 1rem; color: #ff8c00; font-weight: bold;">
                    ${result?.beneName || ''}
                  </span>
                  <p style="margin-top: 4.5rem; font-size: 1.125rem; color: black;">${projectName?.titleAr || ' '}</p>
                  <p style="font-size: 1.125rem; color: black; margin-top: 0.8rem;">
                    ${result?.senderName || ''}
                  </p>
                </div>
              </div>
            </div>
          </div>
        `;

      // Create a new element to render the HTML content for PDF
      const element = document.createElement('div');
      element.innerHTML = htmlContent;
      document.body.appendChild(element);

      // Measure the height of the content
      const contentHeight = element.offsetHeight;
      console.log('Calculated Content Height:', contentHeight); // Debugging log

      // Set a fixed maximum height for A4 size in pixels (for portrait orientation)
      const maxHeight = 1120; // A4 height in pixels approximately

      // Use html2pdf.js to generate PDF and save it to state
      html2pdf()
        .from(element)
        .set({
          margin: [0, 0, 0, 0], // No margins
          filename: 'generated.pdf',
          html2canvas: { scale: 2 }, // Optional for better quality
          jsPDF: {
            unit: 'px',
            format: [450, Math.min(contentHeight, maxHeight)], // Limit height to maxHeight
            orientation: 'portrait',
          },
        })
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const pdfBlob = pdf.output('blob');
          const pdfUrl = URL.createObjectURL(pdfBlob);

          // Save the Blob in the state
          setUserpdf(pdfUrl); // Save Blob URL for rendering

          // Clean up after generating the PDF
          document.body.removeChild(element);
        })
        .catch((error) => {
          console.error('Error generating PDF:', error);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const generatePDFMob = async () => {
    setUserpdf(null);
    try {
      const response = await getAsync(`GiftService/BeneficiaryGiftService/${giftLinkID}`);
      const result = response?.data[0];

      // Dusra API call
      const getprojectName = await postAsync(`APIClient/ProjectListGUIDnoImage`, [`${result?.projectID}`]);
      const projectName = getprojectName?.data[0];
      const htmlContent = `
          <div style="display: flex; justify-content: center; align-items: flex-start; overflow: hidden; width: 100%; height: auto;" id="pdf-content">
            <div style="position: relative; width: 100%; max-width: 450px;  height: auto;">
              <img
                style="width: 100%; height: 584px;"
                src="${imagesArray[result?.giftTypeID - 1].src}"
                alt="Background"
              />
              <div style="text-align: right; position: absolute; top: calc(32% + 14px); right: calc(25% + 12px);">
                <div style="text-align: right; display: flex; flex-direction: column;">
                  <span style="font-size: 1rem; color: #ff8c00; font-weight: bold;">
                    ${result?.beneName || ''}
                  </span>
                  <p style="margin-top: 4.5rem; font-size: 1.125rem; color: black;">${projectName?.titleAr || ' '}</p>
                  <p style="font-size: 1.125rem; color: black; margin-top: 0.7rem;">
                    ${result?.senderName || ''}
                  </p>
                </div>
              </div>
            </div>
                </div>
              </div>
            </div>
          </div>
        `;

      const element = document.createElement('div');
      element.innerHTML = htmlContent;
      document.body.appendChild(element);

      const contentHeight = element.offsetHeight;
      // console.log("Calculated Content Height:", contentHeight);

      const maxHeight = 1120;

      html2pdf()
        .from(element)
        .set({
          margin: [0, 0, 0, 0],
          filename: 'Gift.pdf',
          html2canvas: { scale: 6 },
          jsPDF: {
            unit: 'px',
            format: [450, Math.min(contentHeight, maxHeight)],
            orientation: 'portrait',
          },
        })
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const pdfBlob = pdf.output('blob');
          const pdfUrl = URL.createObjectURL(pdfBlob);
          setUserpdf(pdfUrl);
          document.body.removeChild(element);
        })
        .catch((error) => {
          console.error('Error generating PDF:', error);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Initialize device type and add resize listener
  useEffect(() => {
    const initialDevice = isMobile() ? 'mobile' : 'desktop';
    setCurrentDevice(initialDevice);
    initialDevice === 'mobile' ? generatePDFMob() : generatePDFDesk();

    window.addEventListener('resize', checkDeviceType);
    return () => window.removeEventListener('resize', checkDeviceType);
  }, []); // Empty dependency array to run once on mount

  return (
    <div>
      {userpdf != null ? (
        <object
          data={userpdf}
          type="application/pdf"
          width="100%"
          height="100%"
          style={{ minHeight: '100vh', marginTop: '90px' }}
        >
          {currentDevice == 'mobile' && (
            <p className="px-3 text-center">
              It seems your browser does not support viewing PDFs directly.
              <a className="text-center text-customgreen mt-5" href={userpdf} target="_blank" rel="noopener noreferrer">
                click here to download the PDF file.
              </a>
            </p>
          )}
        </object>
      ) : (
        <LoaderModal className="pt-10" />
      )}
    </div>
  );
};

export default ViewCertificate;
